/*@ngInject*/
const TaskCalendarController = function ($scope, $rootScope, $timeout, coreMediator, formViewerConstant) {

    this.hourStep = 1;
    this.minuteStep = 1;
    this.minDate = new Date();

    this.$onInit = function () {
        let shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        this.format = (this.isTimeEnabled) ? shortDateFormat + ' hh:mm A' : shortDateFormat;
        this.popupOpened = false;
        this.toggleFocus = false;

        if (this.isUtc) {
          this.maximumDate = this.maxDate ? moment.utc(this.maxDate).format('MM/DD/YYYY') : undefined;
          this.textInputDate = this.selectedDate ? moment.utc(new Date(this.selectedDate)).format(this.format) : null;
        } else {
          this.maximumDate = this.maxDate ? moment(this.maxDate).format('MM/DD/YYYY') : undefined;
          this.textInputDate = this.selectedDate ? moment(new Date(this.selectedDate)).format(this.format) : null;
        }

        this.popupDate = this.textInputDate ? moment(this.textInputDate, this.format) : null;
        this.originalDate = this.textInputDate;
    };

    this.$onChanges = function () {

        if (this.isUtc) {
          this.maximumDate = this.maxDate ? moment.utc(this.maxDate).format('MM/DD/YYYY') : undefined;
          this.textInputDate = this.selectedDate ? moment.utc(new Date(this.selectedDate)).format(this.format) : null;
        } else {
          this.maximumDate = this.maxDate ? moment(this.maxDate).format('MM/DD/YYYY') : undefined;
          this.textInputDate = this.selectedDate ? moment(new Date(this.selectedDate)).format(this.format) : null;
        }

        this.popupDate = this.textInputDate ? moment(this.textInputDate, this.format) : null;
        this.originalDate = this.textInputDate;
    };

    this.handleOpen = function (event) {
        $rootScope.$broadcast(formViewerConstant.event.CLOSE_CALENDAR_POPUP);

        $timeout(function() {
            this.popupOpened = true;
        }.bind(this));

        $timeout(function() {
            this.toggleFocus = true;
        }.bind(this), 200);
    };

    this.handleClose = function() {
        this.popupOpened = false;
        this.toggleFocus = false;
        this.updateSelectedDate();
    };

    this.handleBlur = function() {
        this.validateInputDate(this.textInputDate, true);

        if(!this.popupOpened) {
            this.updateSelectedDate();
        }
    };

    this.handleChange = function() {
        this.validateInputDate(this.popupDate);
        if(!this.isTimeEnabled) {
            this.handleClose();
        }
    };

    this.handleKeydown = function (event) {
        if (event.which === 9) {
            this.handleClose();
        }
        return false;
    };

    this.handleKeyup = function (event) {
        if(event.which === 13) {
            this.handleClose();
        }
    };

    this.handleTimeKeyup = function() {
        _.debounce(function() {
            this.validateInputDate(this.popupDate);
        }, 300).bind(this);
    };

    this.validateInputDate = function(date, isString) {
      if (!_.isNil(date)) {
        let momentObj = (isString) ? moment(date, this.format) : moment(new Date(date)),
            dateLengthValid = (isString) ? (date && date.length >= 8) : true,
            isValid = dateLengthValid && momentObj.isValid() && momentObj.isAfter(moment(this.minDate).subtract(1, 'days')),
            formatWith = (this.isTimeEnabled) ? 'MM/DD/YYYY hh:mm A' : 'MM/DD/YYYY';

        if(!isString && !this.originalDate && this.isTimeEnabled) {
            momentObj = moment(new Date(_.replace(date.toString(), '00:00:00', '08:00:00')));
        }

        if (isValid) {
            this.textInputDate = momentObj.format(this.format);
            this.popupDate = moment(this.textInputDate, this.format).format(formatWith);
            this.selectedDate = this.popupDate;
        } else if (date === '') {
            this.textInputDate = null;
            this.popupDate = null;
            this.selectedDate = this.popupDate;
        } else {
            this.textInputDate = (this.originalDate) ? this.originalDate : null;
            this.popupDate = (this.originalDate) ? moment(this.originalDate, this.format).format(formatWith) : null;
        }
      }
    };

    this.updateSelectedDate = function() {
        this.onChange({$value: this.selectedDate});
        this.originalDate = this.selectedDate ? moment(new Date(this.selectedDate)).format(this.format) : null;
    };

    this.isToday = function(date, mode) {
        let today = new Date(),
            year = today.getFullYear();
        today.setHours(12,0,0,0);
        if(today.toDateString() === date.toDateString() || (mode === 'year' && year === date.getFullYear())){
            return 'today';
        }
    };

    $scope.$on(formViewerConstant.event.CLOSE_CALENDAR_POPUP, function () {
        this.popupOpened = false;
    }.bind(this));

};

angular.module('gw-um-submission')
    .controller('taskCalendarController', TaskCalendarController);
